module.exports = __webpack_public_path__ + "static/img/border-5.c1c58a63.png";